import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { MagnetRequirement } from './magnetCalculatorAdvanced';

// Funkcja pomocnicza do czyszczenia polskich znaków
function cleanPolishChars(text: string): string {
  return text
    .replace(/ść/g, 'sc')
    .replace(/ł/g, 'l')
    .replace(/ę/g, 'e')
    .replace(/ą/g, 'a')
    .replace(/ć/g, 'c')
    .replace(/ń/g, 'n')
    .replace(/ó/g, 'o')
    .replace(/ś/g, 's')
    .replace(/ź/g, 'z')
    .replace(/ż/g, 'z')
    .replace(/Ł/g, 'L')
    .replace(/Ę/g, 'E')
    .replace(/Ą/g, 'A')
    .replace(/Ć/g, 'C')
    .replace(/Ń/g, 'N')
    .replace(/Ó/g, 'O')
    .replace(/Ś/g, 'S')
    .replace(/Ź/g, 'Z')
    .replace(/Ż/g, 'Z');
}

export const generateAdvancedMagnetPDF = (
  formData: any,
  result: MagnetRequirement,
  productName: string,
  safetyWarnings: string[]
) => {
  const doc = new jsPDF();
  
  // Ustaw font z obsługą UTF-8
  doc.setFont('helvetica', 'normal');
  
  // === STRONA 1: NAGŁÓWEK I PODSUMOWANIE ===
  
  // Tło nagłówka
  doc.setFillColor(30, 30, 30);
  doc.rect(0, 0, 210, 40, 'F');
  
  // Logo/Nazwa firmy
  doc.setFontSize(28);
  doc.setTextColor(255, 102, 0);
  doc.text('PlexiSystem', 14, 20);
  
  doc.setFontSize(12);
  doc.setTextColor(200, 200, 200);
  doc.text('System Zarzadzania Produkcja', 14, 28);
  
  // Data i numer dokumentu
  doc.setFontSize(10);
  doc.setTextColor(150, 150, 150);
  doc.text(`Data: ${new Date().toLocaleDateString('pl-PL')}`, 150, 20);
  doc.text(`Dokument: KM-${Date.now().toString().slice(-6)}`, 150, 28);
  
  // Tytuł dokumentu
  doc.setFontSize(20);
  doc.setTextColor(40, 40, 40);
  doc.text('Specyfikacja Magnesow Neodymowych', 14, 55);
  
  // Nazwa produktu w ramce
  doc.setDrawColor(255, 102, 0);
  doc.setLineWidth(0.5);
  doc.setFillColor(255, 250, 245);
  doc.roundedRect(14, 60, 182, 15, 2, 2, 'FD');
  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.text(productName, 105, 69, { align: 'center' });
  
  // Kluczowe parametry w kafelkach
  const summaryBoxes = [
    { label: 'Gatunek magnesu', value: result.grade, color: [255, 102, 0] },
    { label: 'Ilosc sztuk', value: `${result.quantity}`, color: [0, 150, 200] },
    { label: 'Sila calkowita', value: `${(result.totalPullForce / 9.81).toFixed(1)} kg`, color: [0, 200, 100] },
    { label: 'Wymiar', value: `O${result.shape.dimensions.diameter}x${result.shape.dimensions.height}mm`, color: [150, 100, 200] }
  ];
  
  let boxX = 14;
  summaryBoxes.forEach((box, i) => {
    // Kafelek
    doc.setFillColor(box.color[0], box.color[1], box.color[2]);
    doc.setDrawColor(box.color[0], box.color[1], box.color[2]);
    doc.setLineWidth(0.3);
    doc.rect(boxX, 85, 44, 25, 'S');
    doc.setFillColor(box.color[0], box.color[1], box.color[2], 20);
    doc.rect(boxX, 85, 44, 25, 'F');


    
    // Etykieta
    doc.setFontSize(9);
    doc.setTextColor(100, 100, 100);
    doc.text(box.label, boxX + 22, 92, { align: 'center' });
    
    // Wartość
    doc.setFontSize(14);
    doc.setTextColor(box.color[0], box.color[1], box.color[2]);
    doc.setFont('helvetica', 'bold');
    doc.text(box.value, boxX + 22, 102, { align: 'center' });
    doc.setFont('helvetica', 'normal');
    
    boxX += 47;
  });
  
  // === WIZUALIZACJA ROZMIESZCZENIA (ULEPSZONA) ===
  
  doc.setFontSize(14);
  doc.setTextColor(40, 40, 40);
  doc.text('Wizualizacja rozmieszczenia magnesow', 14, 125);
  
  const vizY = 135;
  const maxVizWidth = 180;
  const maxVizHeight = 90;
  
  // Oblicz skalę zachowując proporcje
  const scaleX = maxVizWidth / formData.containerWidth;
  const scaleY = maxVizHeight / formData.containerLength;
  const scale = Math.min(scaleX, scaleY) * 0.9; // 90% żeby mieć margines
  
  const drawWidth = formData.containerWidth * scale;
  const drawHeight = formData.containerLength * scale;
  const startX = (210 - drawWidth) / 2;
  
  // Tło dla wizualizacji
  doc.setFillColor(250, 250, 250);
  doc.rect(startX - 10, vizY - 5, drawWidth + 20, drawHeight + 15, 'F');
  
  // Efekt 3D - cień
  doc.setFillColor(200, 200, 200);
  doc.rect(startX + 3, vizY + 3, drawWidth, drawHeight, 'F');
  
  // Główny pojemnik
  doc.setFillColor(255, 255, 255);
  doc.setDrawColor(100, 100, 100);
  doc.setLineWidth(1.5);
  doc.rect(startX, vizY, drawWidth, drawHeight, 'FD');
  
  // Siatka pomocnicza
  doc.setDrawColor(240, 240, 240);
  doc.setLineWidth(0.1);
  for (let i = 1; i < 4; i++) {
    doc.line(startX, vizY + (drawHeight * i / 4), startX + drawWidth, vizY + (drawHeight * i / 4));
    doc.line(startX + (drawWidth * i / 4), vizY, startX + (drawWidth * i / 4), vizY + drawHeight);
  }
  
  // Rysuj magnesy z efektem 3D
  const magnetSize = Math.max(4, (result.shape.dimensions.diameter || 20) * scale);
  
  if (result.arrangement.positions && result.arrangement.positions.length > 0) {
    result.arrangement.positions.forEach((pos, idx) => {
      if (pos && typeof pos.x === 'number' && typeof pos.y === 'number') {
        const x = startX + (pos.x * scale);
        const y = vizY + (pos.y * scale);
        
        // Cień magnesu
        doc.setFillColor(180, 180, 180);
        doc.circle(x + 1, y + 1, magnetSize/2, 'F');
        
        // Główny magnes z gradientem (symulacja)
        const isNorth = idx % 2 === 0;
        if (isNorth) {
          // Biegun N - czerwony
          doc.setFillColor(220, 50, 50);
          doc.circle(x, y, magnetSize/2, 'F');
          doc.setFillColor(255, 100, 100);
          doc.circle(x - magnetSize/6, y - magnetSize/6, magnetSize/3, 'F');
        } else {
          // Biegun S - niebieski
          doc.setFillColor(50, 50, 220);
          doc.circle(x, y, magnetSize/2, 'F');
          doc.setFillColor(100, 100, 255);
          doc.circle(x - magnetSize/6, y - magnetSize/6, magnetSize/3, 'F');
        }
        
        // Obwódka
        doc.setDrawColor(50, 50, 50);
        doc.setLineWidth(0.2);
        doc.circle(x, y, magnetSize/2, 'S');
        
        // Oznaczenie bieguna
        if (result.quantity <= 20) {
          doc.setTextColor(255, 255, 255);
          doc.setFontSize(magnetSize > 8 ? 8 : 6);
          doc.setFont('helvetica', 'bold');
          doc.text(isNorth ? 'N' : 'S', x, y + 1, { align: 'center' });
          doc.setFont('helvetica', 'normal');
        }
      }
    });
  }
  
  // Wymiary z strzałkami
  doc.setDrawColor(100, 100, 100);
  doc.setLineWidth(0.2);
  
  // Szerokość
  const arrowY = vizY + drawHeight + 8;
  doc.line(startX, arrowY, startX + drawWidth, arrowY);
  doc.line(startX, arrowY - 2, startX, arrowY + 2);
  doc.line(startX + drawWidth, arrowY - 2, startX + drawWidth, arrowY + 2);
  doc.setFontSize(9);
  doc.setTextColor(80, 80, 80);
  doc.text(`${formData.containerWidth} mm`, startX + drawWidth/2, arrowY + 4, { align: 'center' });
  
  // Wysokość (długość pojemnika)
  const arrowX = startX - 8;
  doc.line(arrowX, vizY, arrowX, vizY + drawHeight);
  doc.line(arrowX - 2, vizY, arrowX + 2, vizY);
  doc.line(arrowX - 2, vizY + drawHeight, arrowX + 2, vizY + drawHeight);
  // Tekst obrócony dla wymiaru pionowego
  doc.setFontSize(9);
  doc.setTextColor(80, 80, 80);
  // Rysuj tekst litera po literze w pionie
  const heightText = `${formData.containerLength} mm`;
  const charHeight = 4;
  const textStartY = vizY + drawHeight/2 - (heightText.length * charHeight / 2);
  for (let i = 0; i < heightText.length; i++) {
    doc.text(heightText[i], arrowX - 5, textStartY + i * charHeight);
  }
  
  // Legenda
  const legendY = vizY + drawHeight + 20;
  doc.setFontSize(9);
  doc.setTextColor(60, 60, 60);
  doc.text('Legenda:', startX, legendY);
  
  // N pole
  doc.setFillColor(220, 50, 50);
  doc.circle(startX + 25, legendY - 2, 3, 'F');
  doc.text('Biegun N', startX + 30, legendY);
  
  // S pole
  doc.setFillColor(50, 50, 220);
  doc.circle(startX + 65, legendY - 2, 3, 'F');
  doc.text('Biegun S', startX + 70, legendY);
  
  // Układ
  doc.text(`Uklad: ${result.arrangement.rows} x ${result.arrangement.cols} (${result.arrangement.pattern})`, startX + 105, legendY);
  
  // === PARAMETRY SZCZEGÓŁOWE ===
  
  let currentY = legendY + 15;
  
  if (currentY > 250) {
    doc.addPage();
    currentY = 20;
  }
  
  doc.setFontSize(14);
  doc.setTextColor(255, 102, 0);
  doc.text('PARAMETRY SZCZEGOLOWE', 14, currentY);
  
  // Tabela parametrów wejściowych
  const inputData = [
    ['Parametr', 'Wartosc', 'Uwagi'],
    ['Wymiary pojemnika', `${formData.containerWidth} x ${formData.containerLength} x ${formData.containerHeight} mm`, ''],
    ['Waga pojemnika', `${formData.containerWeight} kg`, ''],
    ['Waga zawartosci', `${formData.contentWeight} kg`, ''],
    ['Waga calkowita', `${(formData.containerWeight + formData.contentWeight).toFixed(2)} kg`, 'OK - Obliczona'],
    ['Orientacja montazu', formData.orientation === 'vertical' ? 'Pionowa' : formData.orientation === 'horizontal' ? 'Pozioma' : `Pod katem ${formData.angle} st.`, formData.orientation === 'horizontal' ? 'UWAGA: Wymaga wiekszej sily' : ''],
    ['Grubosc blachy', `${formData.steelThickness} mm`, formData.steelThickness < 2 ? 'UWAGA: Redukcja sily!' : 'OK'],
    ['Temperatura pracy', `${formData.temperature} st.C`, formData.temperature > 60 ? 'UWAGA: Wysoka temp.' : 'OK'],
    ['Wspolczynnik bezp.', `${formData.safetyFactor}x`, ''],
    ['Stan powierzchni', formData.surfaceCondition === 'clean' ? 'Czysta' : formData.surfaceCondition === 'painted' ? 'Malowana' : 'Nierowna', formData.surfaceCondition !== 'clean' ? 'UWAGA: Redukcja sily' : 'OK - Optymalna']
  ];
  
  (doc as any).autoTable({
    startY: currentY + 5,
    head: [inputData[0]],
    body: inputData.slice(1),
    theme: 'striped',
    styles: {
      font: 'helvetica',
      fontSize: 9,
      cellPadding: 3
    },
    headStyles: {
      fillColor: [255, 102, 0],
      textColor: 255
    },
    columnStyles: {
      0: { cellWidth: 40, fontStyle: 'bold' },
      1: { cellWidth: 55 },
      2: { cellWidth: 45, textColor: [100, 100, 100] }
    }
  });
  
  // === STRONA 2: WYNIKI I BHP ===
  
  doc.addPage();
  
  // Nagłówek strony 2
  doc.setFillColor(245, 245, 245);
  doc.rect(0, 0, 210, 15, 'F');
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  doc.text('PlexiSystem - Specyfikacja Magnesow', 14, 10);
  doc.text(`Strona 2/2`, 190, 10);
  
  // Wyniki obliczeń
  doc.setFontSize(16);
  doc.setTextColor(40, 40, 40);
  doc.text('WYNIKI OBLICZEN', 14, 30);
  
  const resultsData = [
    ['Parametr', 'Wartosc', 'Szczegoly'],
    ['Gatunek magnesu', result.grade, `Max temp: ${result.grade.includes('SH') ? '150 st.C' : result.grade.includes('H') ? '120 st.C' : result.grade.includes('M') ? '100 st.C' : '80 st.C'}`],
    ['Wymiary magnesu', `O${result.shape.dimensions.diameter} x ${result.shape.dimensions.height} mm`, `Ksztalt: ${result.shape.type === 'disc' ? 'Krazek' : result.shape.type}`],
    ['Ilosc magnesow', `${result.quantity} szt.`, `Uklad: ${result.arrangement.rows}x${result.arrangement.cols}`],
    ['Odstep miedzy magnesami', `${result.arrangement.spacing.toFixed(1)} mm`, ''],
    ['Sila pojedynczego magnesu', `${result.singleMagnetForce.toFixed(1)} N`, `ok. ${(result.singleMagnetForce / 9.81).toFixed(1)} kg`],
    ['Sila calkowita', `${result.totalPullForce.toFixed(1)} N`, `ok. ${(result.totalPullForce / 9.81).toFixed(1)} kg`],
    ['Wspolczynnik bezpieczenstwa', `${((result.totalPullForce / (formData.containerWeight + formData.contentWeight) / 9.81)).toFixed(1)}x`, result.totalPullForce / ((formData.containerWeight + formData.contentWeight) * 9.81) >= formData.safetyFactor ? 'OK - Spelniony' : 'UWAGA: Za niski!']
  ];
  
  (doc as any).autoTable({
    startY: 35,
    head: [resultsData[0]],
    body: resultsData.slice(1),
    theme: 'grid',
    styles: {
      font: 'helvetica',
      fontSize: 10,
      cellPadding: 4
    },
    headStyles: {
      fillColor: [0, 150, 200],
      textColor: 255
    },
    columnStyles: {
      0: { cellWidth: 50, fontStyle: 'bold' },
      1: { cellWidth: 40, textColor: [0, 100, 200] },
      2: { cellWidth: 50 }
    }
  });
  
  currentY = (doc as any).lastAutoTable.finalY + 10;
  
  // Ostrzeżenia
  if (result.warnings && result.warnings.length > 0) {
    doc.setFillColor(255, 240, 240);
    doc.setDrawColor(255, 100, 100);
    doc.setLineWidth(0.5);
    doc.roundedRect(14, currentY, 182, 8 + result.warnings.length * 6, 2, 2, 'FD');
    
    doc.setFontSize(11);
    doc.setTextColor(200, 0, 0);
    doc.text('OSTRZEZENIA:', 18, currentY + 6);
    
    doc.setFontSize(9);
    doc.setTextColor(150, 0, 0);
    result.warnings.forEach((warning, i) => {
      const cleanWarning = cleanPolishChars(warning);
      doc.text(`• ${cleanWarning}`, 20, currentY + 12 + i * 5);
    });
    
    currentY += 15 + result.warnings.length * 5;
  }
  
  // Rekomendacje
  if (result.recommendations && result.recommendations.length > 0) {
    doc.setFillColor(240, 250, 255);
    doc.setDrawColor(100, 150, 255);
    doc.setLineWidth(0.5);
    doc.roundedRect(14, currentY, 182, 8 + result.recommendations.length * 6, 2, 2, 'FD');
    
    doc.setFontSize(11);
    doc.setTextColor(0, 100, 200);
    doc.text('REKOMENDACJE:', 18, currentY + 6);
    
    doc.setFontSize(9);
    doc.setTextColor(0, 80, 150);
    result.recommendations.forEach((rec, i) => {
      const cleanRec = cleanPolishChars(rec);
      doc.text(`• ${cleanRec}`, 20, currentY + 12 + i * 5);
    });
    
    currentY += 15 + result.recommendations.length * 5;
  }
  
  // Instrukcje BHP
  currentY += 5;
  
  doc.setFillColor(255, 50, 50);
  doc.rect(14, currentY, 182, 8, 'F');
  doc.setFontSize(12);
  doc.setTextColor(255, 255, 255);
  doc.text('INSTRUKCJE BHP I BEZPIECZENSTWO', 105, currentY + 5.5, { align: 'center' });
  
  currentY += 12;
  
  const safetyIcons = {
    'magnet': '🧲',
    'heart': '❤️',
    'warning': '⚠️',
    'hand': '✋',
    'eye': '👁️',
    'temp': '🌡️'
  };
  
  const bhpSections = [
    {
      icon: '[!]',
      title: 'SILA PRZYCIAGANIA',
      items: [
        'Magnesy moga przyciagnac sie z sila ' + (result.totalPullForce / 9.81).toFixed(0) + ' kg!',
        'Ryzyko przytrzasniecia palcow - uzywaj rekawic ochronnych',
        'Montuj magnesy pojedynczo, zachowujac bezpieczna odleglosc',
        'Przy wiekszych magnesach pracuj w 2 osoby'
      ]
    },
    {
      icon: '[<3]',
      title: 'ROZRUSZNIKI SERCA',
      items: [
        'Zachowaj min. 30 cm odleglosci od rozrusznikow serca',
        'Ostrzez osoby z implantami medycznymi',
        'Nie nos magnesow w kieszeniach'
      ]
    },
    {
      icon: '[O]',
      title: 'OCHRONA OSOBISTA',
      items: [
        'Magnesy sa kruche - moga pekac przy uderzeniu',
        'Uzywaj okularow ochronnych',
        'Nie upuszczaj magnesow',
        'Przechowuj w bezpiecznym opakowaniu'
      ]
    },
    {
      icon: '[E]',
      title: 'URZADZENIA ELEKTRONICZNE',
      items: [
        'Trzymaj z dala od kart kredytowych i magnetycznych',
        'Min. 20 cm od dyskow twardych i pamieci',
        'Moze zaklocac dzialanie zegarkow'
      ]
    }
  ];
  
  bhpSections.forEach((section) => {
    if (currentY > 250) {
      doc.addPage();
      currentY = 20;
    }
    
    // Nagłówek sekcji
    doc.setFillColor(250, 250, 250);
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.3);
    doc.roundedRect(14, currentY, 182, 7, 2, 2, 'FD');
    
    doc.setFontSize(10);
    doc.setTextColor(50, 50, 50);
    doc.setFont('helvetica', 'bold');
    doc.text(`${section.icon} ${section.title}`, 18, currentY + 5);
    doc.setFont('helvetica', 'normal');
    
    currentY += 9;
    
    // Elementy listy
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);
    section.items.forEach(item => {
      doc.text(`• ${item}`, 20, currentY);
      currentY += 5;
    });
    
    currentY += 3;
  });
  
  // Stopka
  const pageCount = doc.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    
    // Linia stopki
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.5);
    doc.line(14, 280, 196, 280);
    
    doc.setFontSize(8);
    doc.setTextColor(130, 130, 130);
    doc.text('PlexiSystem (c) 2025 - System Zarzadzania Produkcja', 14, 285);
    doc.text(`Strona ${i} z ${pageCount}`, 190, 285, { align: 'right' });
    doc.text('www.plexisystem.pl', 105, 290, { align: 'center' });
  }
  
  // Zapisz PDF
  const fileName = `PlexiSystem_Magnesy_${productName.replace(/[^a-z0-9]/gi, '_')}_${new Date().toISOString().split('T')[0]}.pdf`;
  doc.save(fileName);
};